import { Paginator } from '@creditflowresearch/uilib/Paginator';
import { useCorporateBondScreenerContext } from '@/creditflowresearch/application/CorporateBondScreener/CorporateBondScreenerContext';
import { useCorporateBondScreenerDictionariesContext } from '@/creditflowresearch/application/CorporateBondScreener/CorporateBondScreenerDictionariesContext';
import { TableDictionariesProvider } from '@/creditflowresearch/application/TableDictionaries';
import { BondScreenerTable } from '@/creditflowresearch/ui/common/components/DataTable/BondScreenerTable';
import type { ICorporateBondScreenerTrancheResponse } from '@/creditflowresearch/domain/vo/Bondscreener/ICorporateBondScreenerTranche';
import { useDynamicColumns } from '../Table/hooks/useDynamicColumns';

export const ScreenerTab = () => {
  const dictionaries = useCorporateBondScreenerDictionariesContext();

  const {
    collection,
    isFetching,
    sortBy,
    sortOrder,
    sort,
    page,
    perPage,
    totalCount,
    paginate,
    setItemsPerPage,
  } = useCorporateBondScreenerContext();

  const columns = useDynamicColumns(collection);

  return (
    <TableDictionariesProvider dictionaries={ dictionaries }>
      <BondScreenerTable<ICorporateBondScreenerTrancheResponse>
        dataTest="corporateBondScreenerTable"
        columns={ columns }
        data={ collection }
        isFetching={ isFetching }
        sortBy={ sortBy }
        sortOrder={ sortOrder }
        onSortChange={ sort }
        emptyMessage="No matching records found"
      />
      <Paginator
        dataTest="corporateBondScreenerPaginator"
        totalCount={ totalCount }
        page={ page }
        perPage={ perPage }
        onPageChange={ ({ selected }) => paginate(selected) }
        onItemsPerPageChange={ ({ value }) => setItemsPerPage(value) }
      />
    </TableDictionariesProvider>
  );
};
